import {checkSiteSlug} from '@/api/sites';
import {useEffect, useState} from 'react';
import {useQuery} from '@tanstack/react-query';

/**
 * Owner-scoped sibling of `useSlugCheck`: same 500ms debounce, but asks the
 * endpoint that knows which site is asking, so the site's own previous
 * addresses read as available.
 */
export function useSiteSlugCheck(siteId: string, slug: string) {
    const [debouncedSlug, setDebouncedSlug] = useState('');

    useEffect(() => {
        if (!slug || slug.length < 3) {
            setDebouncedSlug('');
            return;
        }

        const timer = setTimeout(() => {
            setDebouncedSlug(slug);
        }, 500);

        return () => clearTimeout(timer);
    }, [slug]);

    return useQuery({
        queryKey: ['site-slug-check', siteId, debouncedSlug],
        queryFn: () => checkSiteSlug(siteId, debouncedSlug),
        enabled: !!siteId && debouncedSlug.length >= 3,
        retry: false,
        staleTime: 10_000
    });
}
